module.exports = __webpack_public_path__ + "site/img/44.0399d995.jpg";